import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useState, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';
import { useFormContext } from '../Form/Form.js';
import { FormControl } from '../FormControl/FormControl.js';
import Select from '../Select/Select.js';

const FormSelect = ({ id , name , label , options , errorMessage , className , tooltipLabel , placeholder , onChange , initialState , disabled =false , required =false , hideAsteriskSign =false ,  })=>{
    var ref, ref1;
    const [value, setValue] = useState(initialState && initialState.value || '');
    const [isTouched, setIsTouched] = useState(initialState && initialState.isTouched || false);
    const isValid = useMemo(()=>FormControl.validate([], [], required, value, errorMessage).isValid
    , [
        errorMessage,
        required,
        value
    ]);
    const readonly = initialState && initialState.readonly;
    const selectValue = (ref = Object.entries(options).find(([_, opt])=>opt.value === value
    )) === null || ref === void 0 ? void 0 : (ref1 = ref[1]) === null || ref1 === void 0 ? void 0 : ref1.label;
    React.useEffect(()=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(swcHelpers.objectSpread({
            value,
            name,
            errorMessage,
            isValid,
            isTouched
        }, readonly === undefined ? {} : {
            readonly
        }));
    }, [
        onChange,
        value,
        name,
        isValid,
        isTouched,
        errorMessage,
        readonly
    ]);
    React.useEffect(()=>{
        setValue((initialState === null || initialState === void 0 ? void 0 : initialState.value) || '');
        setIsTouched((initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || false);
    }, [
        initialState === null || initialState === void 0 ? void 0 : initialState.value,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched
    ]);
    const handleChange = useCallback((option)=>{
        setValue(option.value);
        setIsTouched(true);
    }, [
        required
    ]);
    const classes = classnames(`${name}-select__input`, {
        _is_valid: isValid && isTouched && !readonly,
        _is_invalid: !isValid && isTouched && !readonly
    });
    return /*#__PURE__*/ React.createElement("label", {
        className: classnames('form-control', `${name}-select`, className)
    }, label && /*#__PURE__*/ React.createElement("div", {
        className: "form-control__label"
    }, label, required && !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__asterisk"
    }, "*"), tooltipLabel && /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${name}-tooltip`,
        message: tooltipLabel
    })), /*#__PURE__*/ React.createElement("div", {
        className: "form-control__wrapper"
    }, /*#__PURE__*/ React.createElement(Select, {
        className: classes,
        id: id,
        name: name,
        placeholder: placeholder,
        options: options,
        initialState: {
            value: selectValue || '',
            isTouched,
            isValid,
            errorMessage
        },
        onChange: handleChange,
        disabled: disabled || readonly,
        "aria-invalid": !isValid,
        "aria-describedby": `${name}-select-error`
    })), !isValid && isTouched && /*#__PURE__*/ React.createElement("span", {
        id: `${name}-select-error`,
        className: "form-control__error"
    }, errorMessage));
};
const ConnectedFormSelect = (props)=>{
    const { getInitialState , onChange  } = useFormContext();
    const handleChange = React.useCallback((formControlState)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(formControlState);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(FormSelect, swcHelpers.extends({}, props, {
        onChange: handleChange,
        initialState: (getInitialState === null || getInitialState === void 0 ? void 0 : getInitialState(props.name)) || props.initialState
    }));
};

export { ConnectedFormSelect, FormSelect };
//# sourceMappingURL=FormSelect.js.map
